// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function southAfricanOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'za',
    document: userInputValues['southAfricanDocument'],
    zipcode: userInputValues['southAfricanZipcode'],
    state: userInputValues['southAfricanState'],
    city: userInputValues['southAfricanCity'],
    address: userInputValues['southAfricanAddress'],
    street_number: userInputValues['southAfricanStreetNumber'],
    street_complement: userInputValues['southAfricanStreetComplement'],
    phone_number: userInputValues['southAfricanPhoneNumber'],
  };
}
